import * as types from './types';
import { get } from 'lodash';
import { fetchGet, fetchPost } from '../api/fetch';
import { openSnackBar } from '../actions/snackbarAction';
import { logOut } from '../actions/loginActions';

export function onDoubtTopicResponse(response) {
  return {
    type: types.DOUBT_TOPIC_RESPONSE,
    response,
  };
}
////new member list
export function onFetchMemberListResponse(response) {
  return {
    type: types.FETCH_MEMBER_LIST_RESPONSE,
    response,
  };
}
/* end */
export function onFetchQuestionListResponse(response) {
  return {
    type: types.FETCH_QUESTION_LIST_RESPONSE,
    response,
  };
}
export function onFetchCommentListResponse(response) {
  return {
    type: types.FETCH_COMMENT_LIST_RESPONSE,
    response,
  };
}

export const studentDiscussionFetch = async (jwtToken, dispatch) => {
  const url = 'api/StudentDiscussionForum';
  await fetchGet(url, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      dispatch(onDoubtTopicResponse(data));
    });
};




export const studentQuestionList = async (forumCode, jwtToken, dispatch) => {
  const url = `api/studentdfquestionlist/${forumCode}`;
  await fetchGet(url, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      dispatch(onFetchQuestionListResponse(data));
    });
};


///// get member List
export const studentMemberList = async (forumCode, jwtToken, dispatch) => {
  const url = `api/student/forum/member/${forumCode}`;
  await fetchGet(url, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      dispatch(onFetchMemberListResponse(data));
    });
}; 

//BookMark / unMark Question
export const bookMarkQuestion = async (
  questionCode,
  action,
  jwtToken,
  dispatch,
  forumCode,
) => {
  const body = {
    Action: parseInt(action),
    DFQID: parseInt(questionCode),
  };
  const url = 'api/studentbookmarkquestion';
  await fetchPost(url, body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then((/*data*/) => {
      // if (data.error) {
      //   console.log('Issue occured');
      // } else if (!get(data, 'IsLoggedIn', true)) {
      //   dispatch(
      //     openSnackBar({
      //       message: 'Multiple logins detected, please login again to continue',
      //       severity: 'warning',
      //     }),
      //   );
      //   dispatch(logout());
      // }
      return dispatch(
        action === 4
          ? openSnackBar({
              message: 'Question Bookmarked',
              severity: 'success',
            })
          : openSnackBar({
              message: 'Bookmarked Removed ',
              severity: 'success',
            }),
      );
    });
  studentQuestionList(forumCode, jwtToken, dispatch);
};

export const studentDiscussionComments = async (
  forumId,
  dfdid,
  jwtToken,
  dispatch,
) => {
  const url = `api/student/forum/discussion/${forumId}/${dfdid}`;

  await fetchGet(url, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
      dispatch(onFetchCommentListResponse(data));
    });
};

// * Like/Dislike Comments
export const likeDislikeComment = (action, id, jwtToken, dispatch) => {
  let body = {
    Action: action,
    DFQID: id,
  };
  fetchPost('api/studentdlikedislikecomment', body, jwtToken)
    .then(res => {
      return res.json();
    })
    .then(data => {
      if (data.error && !Object.keys(data).includes('data')) {
        return dispatch(
          openSnackBar({ message: 'Some error occurred', severity: 'error' }),
        );
      }
      if (!get(data, 'IsLoggedIn', true)) {
        dispatch(
          openSnackBar({
            message: 'Multiple logins detected, please login again to continue',
            severity: 'warning',
          }),
        );
        return dispatch(logOut());
      }
    });
};

export const submitQuestion = async (
  title,
  desc,
  forumCode,
  auth,
  image,
  dispatch,
) => {
  let QuestionTitle = title.replace(/^\s+|\s+$/gm, '');
  let QDesc = desc.replace(/^\s+|\s+$/gm, '');
  try {
    if (!QuestionTitle || !forumCode || !auth || !(QDesc || image)) {
      dispatch(
        openSnackBar({
          message: 'Please enter the required field',
          severity: 'warning',
        }),
      );
      return Promise.reject();
    }

    const url = 'api/studentdsubmitquestion';
    let body = {
      ForumCode: forumCode,
      QuestionTitle: QuestionTitle,
      QuestionDetail: QDesc,
    };

    if (image) {
      body.QuestionImage = image;
    }

    await fetchPost(url, body, auth)
      .then(res => {
        return res.json();
      })
      .then(data => {
        if (data.error && !Object.keys(data).includes('data')) {
          return dispatch(
            openSnackBar({ message: 'Some error occurred', severity: 'error' }),
          );
        }
        if (!get(data, 'IsLoggedIn', true)) {
          dispatch(
            openSnackBar({
              message:
                'Multiple logins detected, please login again to continue',
              severity: 'warning',
            }),
          );
          return dispatch(logOut());
        }
        return dispatch(
          openSnackBar({
            message: 'Doubt submitted for moderation',
            severity: 'success',
          }),
        );
      });
  } catch (err) {
    console.log('Error - ', err);
  }
};

export const submitComment = async (
  desc,
  questionCode,
  image,
  auth,
  dispatch,
) => {
  let CommentDesc = desc.replace(/^\s+|\s+$/gm, '');
  try {
    if (!(questionCode && auth && (CommentDesc || image))) {
      dispatch(
        openSnackBar({
          message: 'Please enter the required field',
          severity: 'warning',
        }),
      );
      return Promise.reject();
    }

    const url = 'api/studentdsubmitcomment';
    let body = {
      QuestionCode: questionCode,
    };
    if (desc) {
      body.DiscussionDetail = CommentDesc;
    }
    if (image) {
      body.DiscussionImage = image;
    }

    await fetchPost(url, body, auth)
      .then(res => {
        return res.json();
      })
      .then(data => {
        if (data.error && !Object.keys(data).includes('data')) {
          return dispatch(
            openSnackBar({ message: 'Some error occurred', severity: 'error' }),
          );
        }
        if (!get(data, 'IsLoggedIn', true)) {
          dispatch(
            openSnackBar({
              message:
                'Multiple logins detected, please login again to continue',
              severity: 'warning',
            }),
          );
          return dispatch(logOut());
        }
        return dispatch(
          openSnackBar({
            message: 'Comment submitted successfully',
            severity: 'success',
          }),
        );
      });
  } catch (err) {
    dispatch(
      openSnackBar({
        message: 'Please enter the required field',
        severity: 'warning',
      }),
    );
  }
};
